// @flow
import React, { Children, Fragment, type Node } from 'react';
import classnames from 'classnames';

import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';

import { Icon, type IconName } from 'Components/frameworks/icon/Icon.jsx';

import { styles } from './Capsule.styles';

const SMALL: 'small' = 'small';
const LARGE: 'large' = 'large';
const AUTO: 'auto' = 'auto';
const NONE: 'none' = 'none';

type Props = {
  additionalStyle?: {
    root?: {},
    header?: {},
    content?: {},
    icon?: {},
    label?: {},
  },
  children?: Node,
  className?: string,
  color?: string,
  header?: typeof SMALL | typeof LARGE | typeof AUTO | typeof NONE,
  icon?: IconName,
  label?: string,
  upside?: boolean,
  validated?: boolean,
};

export function Capsule(props: Props) {
  const {
    additionalStyle,
    children,
    className,
    color,
    header = SMALL,
    icon = ICONS.ALL_INCLUSIVE,
    label,
    upside,
    validated,
  } = props;

  const isLargeHeader = header === LARGE;
  const isHeaderNone = header === NONE;
  const isHeaderAuto = header === AUTO;
  const {
    computedCapsuleStyle,
    computedCheckIconStyle,
    computedContentStyle,
    computedHeaderStyle,
    computedIconWrapperStyle,
    computedLabelStyle,
  } = styles({
    additionalStyle,
    color,
    isHeaderNone,
    isLargeHeader,
    isHeaderAuto,
    upside,
  });

  if (!Children.count(children)) return null;
  return (
    <section className={classnames(className, 'Capsule')} style={computedCapsuleStyle}>
      {header !== 'none' && (
        <div style={computedHeaderStyle}>
          {(isLargeHeader || isHeaderAuto) && (
            <Fragment>
              <div style={computedIconWrapperStyle}>
                <Icon name={icon} width={computedIconWrapperStyle.width || '1.25rem'} />
              </div>
              <span>&nbsp;</span>
              <span style={computedLabelStyle}>{label}</span>
            </Fragment>
          )}
        </div>
      )}
      <div style={computedContentStyle}>
        {validated && (
          <div style={{ position: 'relative' }}>
            <div style={computedCheckIconStyle}>
              <Icon color={COLORS.SUCCESS} name={ICONS.SMALL_CIRCLE_CHECK} width="3rem" />
            </div>
          </div>
        )}
        {children}
      </div>
    </section>
  );
}
